/* ============================================================
   PAW4EVER THEME JS
   ============================================================ */

document.addEventListener('DOMContentLoaded', function() {

  /* --- FAQ Accordions --- */
  document.querySelectorAll('.faq-question').forEach(function(q) {
    q.addEventListener('click', function() {
      this.parentElement.classList.toggle('open');
      var expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !expanded);
    });
    q.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.click();
      }
    });
  });

  /* --- Quantity Controls --- */
  document.querySelectorAll('.qty-plus').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var input = this.parentElement.querySelector('.qty-value');
      input.value = parseInt(input.value || 1) + 1;
    });
  });
  document.querySelectorAll('.qty-minus').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var input = this.parentElement.querySelector('.qty-value');
      var val = parseInt(input.value || 1);
      if (val > 1) input.value = val - 1;
    });
  });

  /* --- Variant Selection --- */
  document.querySelectorAll('.variant-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var parent = this.closest('.variant-selector');
      parent.querySelectorAll('.variant-btn').forEach(function(b) {
        b.classList.remove('active');
      });
      this.classList.add('active');

      // Update selected label
      var optionIndex = this.getAttribute('data-option-index');
      var label = parent.querySelector('.selected-option-' + optionIndex);
      if (label) label.textContent = this.getAttribute('data-value');

      // Find matching variant
      updateVariantSelection();
    });
  });

  function updateVariantSelection() {
    var selects = document.querySelectorAll('.variant-select');
    if (selects.length === 0) return;

    var selectedOptions = [];
    document.querySelectorAll('.variant-selector').forEach(function(selector) {
      var active = selector.querySelector('.variant-btn.active');
      if (active) selectedOptions.push(active.getAttribute('data-value'));
    });

    var matchTitle = selectedOptions.join(' / ');

    selects.forEach(function(select) {
      for (var i = 0; i < select.options.length; i++) {
        if (select.options[i].textContent.trim() === matchTitle) {
          select.selectedIndex = i;

          // Update price display
          var priceEl = document.querySelector('.price-current');
          if (priceEl && select.options[i].dataset.price) {
            priceEl.textContent = select.options[i].dataset.price;
          }

          // Update add-to-cart button state
          var addBtn = document.querySelector('.btn-add-cart');
          if (addBtn) {
            if (select.options[i].disabled) {
              addBtn.disabled = true;
              addBtn.textContent = 'Sold Out';
            } else {
              addBtn.disabled = false;
              addBtn.textContent = addBtn.getAttribute('data-default-text') || 'Add to Cart - Free Shipping';
            }
          }
          break;
        }
      }
    });
  }

  /* --- Smooth scroll for anchor links --- */
  document.querySelectorAll('a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        var offset = 80; // account for sticky nav
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  });

  /* --- Store default add-to-cart text --- */
  var addBtn = document.querySelector('.btn-add-cart');
  if (addBtn) {
    addBtn.setAttribute('data-default-text', addBtn.textContent.trim());
  }

});
